import React, { Suspense } from 'react';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import Loading from '@/components/Loading';
import GlobalTool from '@/components/Tool';
interface IRouters {
  name: string;
  path: string;
  component: any;
  children?: IRouters[];
}

let routes: IRouters[] = [];
// @ts-ignore
const registerRouter = require.context('@/views', true, /router\.ts$/i);
registerRouter.keys().forEach((fileName: string) => {
  let file = registerRouter(fileName).default;
  routes.push(file);
});

export default () => {
  function handlerRoutes(router: IRouters[]): any {
    return router.map(({ path, component, children, name }) => {
      if (children) {
        return handlerRoutes(children!);
      }
      return <Route exact path={path} key={name} component={component} />;
    });
  }
  return (
    <Router>
      <Suspense fallback={Loading()}>
        <Switch>{handlerRoutes(routes)}</Switch>
        <GlobalTool />
      </Suspense>
    </Router>
  );
};
